import { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Splash, useAuth } from '@mobi/web';
import { Auth } from './pages/Auth.js';
import { Home } from './pages/Home.js';
import { Earnings } from './pages/Earnings.js';
import { Profile } from './pages/Profile.js';
import { Shell } from './components/Shell.js';

export function App() {
  const { user, loading } = useAuth();
  // A troca para a tela real só acontece quando o splash termina a
  // própria saída — não quando `loading` vira false. Sem isto o app
  // corta o splash no meio da animação assim que a sessão resolve rápido.
  const [splashDone, setSplashDone] = useState(false);

  if (!splashDone) {
    return (
      <Splash
        appName="Motorista"
        tagline="Corridas por perto, na hora"
        ready={!loading}
        onFinished={() => setSplashDone(true)}
      />
    );
  }

  if (!user) return <Auth />;

  return (
    <Routes>
      <Route element={<Shell />}>
        <Route path="/" element={<Home />} />
        <Route path="/ganhos" element={<Earnings />} />
        <Route path="/perfil" element={<Profile />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}
